/*
  カートページ上でのクーポン適用制御

  ご購入手続きへボタンをクリックした際に、クーポンが選択されていればクーポン適用処理を行う
*/
const loadCouponList = () => {
  // Modal表示
  const couponListModalContents = document.getElementById(
      "coupon-list-contents"
    ),
    couponListModal = document.getElementById("coupon-list-modal");
  if (couponListModalContents) {
    couponListModal.innerHTML = couponListModalContents.innerHTML;
    couponListModalContents.innerHTML = "";

    const openModalBtn = document.getElementById("show-coupon-list-modal");
    const modal = document.getElementById("coupon-list-modal");
    const closeBtn = document.getElementById("close-coupon-list-modal");
    const modalBackground = document.getElementById("bg-coupon-list-modal");

    if (openModalBtn) {
      openModalBtn.onclick = function () {
        modal.classList.add("show");
        setTimeout(() => {
          modal.style.display = "block";
        }, 10);
      };
    }

    if (closeBtn) {
      closeBtn.onclick = function () {
        modal.classList.remove("show");
        setTimeout(() => {
          modal.style.display = "none";
        }, 500);
      };
    }

    if (modalBackground) {
      modalBackground.onclick = function () {
        modal.classList.remove("show");
        setTimeout(() => {
          modal.style.display = "none";
        }, 500);
      };
    }
  } else {
    couponListModal.innerHTML = "";
  }

  // クーポン適用処理
  const applyCouponButtonList = document.querySelectorAll(
      "[data-apply-coupon-code]"
    ),
    checkoutBtn = document.querySelector('[name="checkout"]'),
    nameDiscount = document.querySelector('[name="discount"]'),
    couponCheckboxList = document.querySelectorAll("[data-coupon-checkbox]");

  // クーポン選択時、valueが同じ他のチェックボックスも同時にチェックする(使えるクーポン用)
  couponCheckboxList.forEach(function (couponCheckbox) {
    couponCheckbox.addEventListener("change", function (e) {
      const otherCheckbox = document.querySelector(
        `[data-coupon-checkbox][value="${e.target.value}"]:not(#${e.target.id})`
      );
      if (otherCheckbox) {
        otherCheckbox.checked = e.target.checked;
      }

      // クーポンが5つ選択された場合、それ以上選択できないようにする
      const checkedCouponList = document.querySelectorAll(
        "[data-coupon-checkbox]:not([data-max-coupon]):checked"
      );
      if (checkedCouponList.length >= 5) {
        couponCheckboxList.forEach(function (checkbox) {
          if (!checkbox.checked) {
            checkbox.setAttribute("disabled", true);
          }
        });
      } else {
        couponCheckboxList.forEach(function (checkbox) {
          checkbox.removeAttribute("disabled");
        });
      }
    });
  });
  if (document.querySelector("[data-max-coupon]")) {
    document
      .querySelector("[data-max-coupon]")
      .dispatchEvent(new Event("change"));
  }

  if (applyCouponButtonList.length > 0 && nameDiscount) {
    // クーポン選択時、form内にクーポンコードを設定
    applyCouponButtonList.forEach(function (applyCouponButton) {
      applyCouponButton.addEventListener("click", function () {
        applyCouponButton.setAttribute("disabled", true);
        const checkedCouponList = document.querySelectorAll(
          "[data-coupon-checkbox]:checked"
        );

        let couponCode = "";
        if (checkedCouponList.length > 0) {
          checkedCouponList.forEach(function (checkedCoupon, idx) {
            if (idx === 0) {
              couponCode += checkedCoupon.value;
            } else {
              couponCode += "," + checkedCoupon.value;
            }
          });
        }
        nameDiscount.value = couponCode;

        document.querySelector("form.cart").classList.add("loading");

        if (couponCode) {
          window.location.href = `/checkout?discount=${encodeURIComponent(
            couponCode
          )}`;
        } else {
          checkoutBtn.click();
        }
      });
    });
  }
};

window.addEventListener("load", loadCouponList);

// カート更新時の再レンダリング
const updateCartCouponList = (_updateCartTemplate) => {
  const updateCartTemplate = document.createElement("div");
  updateCartTemplate.innerHTML = _updateCartTemplate;
  const updateCouponList =
    updateCartTemplate.querySelector(".cart-coupon-list");

  if (updateCouponList) {
    document.querySelector(".cart-coupon-list").innerHTML =
      updateCouponList.innerHTML;
    loadCouponList();

    // クーポン選択状態の最新化
    const currentCouponValue =
      document.querySelector('[name="discount"]').value;
    document
      .querySelectorAll("[data-coupon-checkbox]")
      .forEach(function (checkbox) {
        if (currentCouponValue.includes(checkbox.value)) {
          checkbox.checked = true;
        } else {
          checkbox.checked = false;
        }
      });
  }
};
